import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as ROOT_NAME } from '../../Root/reducer'
import { isSaving } from '../../Root/saving'
import { NON_NEGATIVE, nonNegativeChange } from '../../Root/nonNegative'
import { NAME as COMPANIES_NAME } from '../reducer'
import { Button, TextField } from '@material-ui/core'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { phoneError, samePhoneWarning } from '../phone'
import { loadCompanyPhones } from '../companyPhones'
import { areaError, LIMITS, tooLongError } from '../fields'
import OblastSelect from './OblastSelect'
import PlaceField from './PlaceField'
import { districtsOf } from '../districts'
import { loadSettlements, locationUpdater, settlementsOf } from '../settlements'

// Цвет предупреждения о повторном номере: оно не ошибка, а повод проверить.
const SAME_PHONE_COLOR = '#b26a00'

function mapStateToProps(state) {
  return {
    ...state[COMPANIES_NAME],
    saving: isSaving(state[ROOT_NAME], 'COMPANY_CREATE')
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...rootActions,
}, dispatch)

function validate(selector) {
  //const regTel = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  let successFlag = 0
  // name validation
  if (!selector.state.name) {
    selector.setState({ errorName: true, helperTextName: "Введите название." })
    successFlag--
  } else if (tooLongError("name", selector.state.name)) {
    selector.setState({ errorName: true, helperTextName: tooLongError("name", selector.state.name) })
    successFlag--
  } else {
    selector.setState({ errorName: false, helperTextName: "" })
    successFlag++
  }
  // Director validation
  if (!selector.state.director) {
    selector.setState({ errorDirector: true, helperTextDirector: "Введите имя директора." })
    successFlag--
  } else if (tooLongError("director", selector.state.director)) {
    selector.setState({ errorDirector: true, helperTextDirector: tooLongError("director", selector.state.director) })
    successFlag--
  } else {
    selector.setState({ errorDirector: false, helperTextDirector: "" })
    successFlag++
  }
  // phone number validation
  const phoneProblem = phoneError(selector.state.phoneNumber)
  if (phoneProblem) {
    selector.setState({ errorPhoneNumber: true, helperTextPhoneNumber: phoneProblem })
    successFlag--
  } else {
    selector.setState({ errorPhoneNumber: false, helperTextPhoneNumber: "" })
    successFlag++
  }
  // area: not below zero, a number
  const areaProblem = areaError(selector.state.generalArea)
  selector.setState({ errorGeneralArea: Boolean(areaProblem), helperTextGeneralArea: areaProblem })
  if (areaProblem) {
    successFlag--
  } else {
    successFlag++
  }
  if (successFlag === 4) { return true }
}

class CreateCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridItemStyle: {
        margin: '10px',
      },
      generalAreaValidationFail: false,

      errorName: false,
      errorGeneralArea: false,
      errorDirector: false,
      errorPhoneNumber: false,

      helperTextName: "",
      helperTextGeneralArea: "",
      helperTextDirector: "",
      helperTextPhoneNumber: "",

      companyType: "Не задано",

      // Населённые пункты по районам (читаются при открытии формы, см. settlements.js).
      settlements: null
    }
  }

  componentDidMount() {
    loadCompanyPhones().then(companies => {
      if (!this.unmounted) this.setState({ companyPhones: companies })
    })
    loadSettlements().then(settlements => {
      if (!this.unmounted) this.setState({ settlements })
    })
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  // Подпись под полем «Населённый пункт», когда выбирать не из чего.
  cityHint() {
    if (!this.state.settlements) return ''
    if (settlementsOf(this.state.settlements, this.state.state, this.state.region).length) return ''
    return this.state.region ? 'Для этого района нет списка: впишите название' : 'Сначала выберите район'
  }


  render() {
    return (
      <Grid component={Paper} container spacing={3}>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="outlined-basic"
              label="Название"
              variant="outlined"
              inputProps={{ maxLength: LIMITS.name }}
              error={this.state.errorName}
              helperText={this.state.helperTextName}
              onChange={e => this.setState({ name: e.target.value, errorName: false, helperTextName: "" })}
            />
          </FormControl>
        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <FormControl fullWidth>
            <TextField
              label="Общее количество земли"
              inputProps={NON_NEGATIVE}
              variant="outlined"
              type="number"
              value={this.state.generalArea}
              error={this.state.errorGeneralArea}
              helperText={this.state.helperTextGeneralArea}
              InputProps={{
                endAdornment: <InputAdornment position="end">Га</InputAdornment>
              }}
              onChange={nonNegativeChange(e => this.setState({ generalArea: e.target.value, errorGeneralArea: false, helperTextGeneralArea: "" }))}
              onBlur={e => {
                const problem = areaError(e.target.value)
                this.setState({ errorGeneralArea: Boolean(problem), helperTextGeneralArea: problem })
              }}
            />
          </FormControl>

        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="outlined-basic"
              label="Имя Директора"
              variant="outlined"
              inputProps={{ maxLength: LIMITS.director }}
              error={this.state.errorDirector}
              helperText={this.state.helperTextDirector}
              onChange={e => this.setState({ director: e.target.value, errorDirector: false, helperTextDirector: "" })}
            />
          </FormControl>
        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="outlined-basic"
              label="Телефон Директора"
              variant="outlined"
              type="tel"
              error={this.state.errorPhoneNumber}
              // Ошибка формата важнее; без неё — предупреждение, если номер уже есть у другой компании.
              helperText={
                this.state.helperTextPhoneNumber ||
                samePhoneWarning(this.state.phoneNumber, this.state.companyPhones || this.props.tableData, undefined)
              }
              FormHelperTextProps={this.state.helperTextPhoneNumber ? undefined : { style: { color: SAME_PHONE_COLOR } }}
              onChange={e => this.setState({ phoneNumber: e.target.value, errorPhoneNumber: false, helperTextPhoneNumber: "" })}
              onBlur={e => {
                // Номер проверяется, как только человек вышел из поля, а не только по кнопке.
                const problem = phoneError(e.target.value)
                this.setState({ errorPhoneNumber: Boolean(problem), helperTextPhoneNumber: problem })
              }}
            />
          </FormControl>
        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <OblastSelect value={this.state.state} onChange={value => this.setState(locationUpdater({ state: value }))} />
        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <PlaceField label="Район" value={this.state.region} options={districtsOf(this.state.state)} helperText={districtsOf(this.state.state).length ? '' : 'Сначала выберите область'} maxLength={LIMITS.region} onChange={value => this.setState(locationUpdater({ region: value }))} />
        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <PlaceField label="Населённый пункт" value={this.state.city} options={settlementsOf(this.state.settlements, this.state.state, this.state.region)} helperText={this.cityHint()} maxLength={LIMITS.city} onChange={value => this.setState({ city: value })} />
        </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
            <FormControl fullWidth>
              <TextField
                id="standard-select-currency"
                select
                label="Тип компании"
                variant="outlined"
                value={this.state.companyType}
                error = {this.state.errorSelectedTypeId}
                onChange={(event) => {
                  this.setState({ companyType: event.target.value, errorSelectedTypeId: false })
                }}
                helperText="Пожалуйста выберите тип компании"
              >
                <MenuItem value="Не задано">
                  <em>Не задано</em>
                </MenuItem>
                <MenuItem value="Сельхозпроизводитель">
                  <em>Сельхозпроизводитель</em>
                </MenuItem>
                <MenuItem value="Завод">
                  <em>Завод</em>
                </MenuItem>
                <MenuItem value="Посредник">
                  <em>Посредник</em>
                </MenuItem>

              </TextField>
            </FormControl>
          </Grid>
        <Grid style={this.state.gridItemStyle} item xs={12}>
          <FormControl fullWidth>
            <Button variant="contained" color="primary" disabled={this.props.saving}
              onClick={() => {
                if (validate(this)) {
                  this.props.createCompany({
                    name: this.state.name,
                    generalArea: this.state.generalArea,
                    director: this.state.director,
                    phoneNumber: this.state.phoneNumber,
                    state: this.state.state,
                    region: this.state.region,
                    city: this.state.city,
                    type: this.state.companyType,
                  }).then((response) => {
                    if (response.payload && response.payload.id) {
                      this.props.redirectTo(`/companypage?id=${response.payload.id}`);
                    }
                  });
                }
              }}>Создать</Button>
          </FormControl>
        </Grid>
      </Grid>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateCompany)
